/**
 * CCP's public image server. No auth, no key, and the only art source this
 * app is allowed to use (see the surface brief) — so every portrait, hull
 * render and corp logo in the UI is built here rather than each call site
 * hand-writing the URL and guessing at a size.
 *
 * `size` must be one of CCP's supported powers of two; anything else 400s.
 * Ask for twice the CSS size so the art stays crisp on a 2x display.
 */
const BASE = 'https://images.evetech.net';

export type EveImageSize = 32 | 64 | 128 | 256 | 512;

/** A ship's 3D render — what a killmail should show. Not every inventory
 * type has one (structures and modules do not), so callers that might hit a
 * non-ship type should fall back to `typeIcon`. */
export const shipRender = (typeId: number, size: EveImageSize = 128) => `${BASE}/types/${typeId}/render?size=${size}`;

/** The flat inventory icon. Always present for every type, which makes it
 * the safe fallback when a render 404s. */
export const typeIcon = (typeId: number, size: EveImageSize = 64) => `${BASE}/types/${typeId}/icon?size=${size}`;

export const characterPortrait = (characterId: number, size: EveImageSize = 64) =>
  `${BASE}/characters/${characterId}/portrait?size=${size}`;

export const corporationLogo = (corporationId: number, size: EveImageSize = 64) =>
  `${BASE}/corporations/${corporationId}/logo?size=${size}`;

export const allianceLogo = (allianceId: number, size: EveImageSize = 64) =>
  `${BASE}/alliances/${allianceId}/logo?size=${size}`;
